import { render, staticRenderFns } from "./CustomerHubActivitySymbol.vue?vue&type=template&id=2a270807&scoped=true"
import script from "./CustomerHubActivitySymbol.vue?vue&type=script&lang=js"
export * from "./CustomerHubActivitySymbol.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubActivitySymbol.vue?vue&type=style&index=0&id=2a270807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a270807",
  null
  
)

export default component.exports